<template>
  <div class="scroll picker-container">
    <div class="month-title" v-if="disableDates && disableDates.ranges && showRangeSlider">
      <span>{{ selectedDates[0].display }}</span>
      <span>{{ selectedDates[1].display }}</span>
    </div>
    <div class="space-element"  v-if="showRangeSlider">
      <vue-slider class="mr-20 ml-20" v-if="sliderValues && sliderValues.length > 0" v-model="monthRange" :max-range="sliderValues[sliderValues.length]" :tooltip="'always'" :data="sliderValues" height="17" :dotSize="40" :dotWidth="20" @drag-end="dragEnd" ref="slider" :marks="true" :formatter="val => (val ? val.toUpperCase() : val)" />
    </div>
    <div class="display-flex pb-5" v-if="disableDatesStart && disableDatesEnd">
      <div class="date-input">
        <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Date" v-model="dataPickerFromValue" :format="datePickerFormat" :disabled-dates="disableDatesStart" name="datepicker" @input="changeFromPicker" ref="startDatePicker"> </datepicker>
        <img src="/static/img/calendar.svg" @click="openStartDatePicker" class="date-cal-icon" />
      </div>
      <div class="date-to">to</div>
      <div class="date-input">
        <datepicker class="text-left" input-class="datepicker-class uploadDocInputField form-control" placeholder="Enter Date" v-model="dataPickerToValue" :format="datePickerFormat" :disabled-dates="disableDatesEnd" @input="changeFromPicker" name="datepickerTo" ref="endDatePicker"> </datepicker>
        <img src="/static/img/calendar.svg" @click="openEndDatePicker" class="date-cal-icon" />
      </div>
    </div>
    <div class="text-right pt-10">
      <b-button class="text-sm btn-clear" @click="clearDateFilter()">Cancel</b-button>
      <b-link variant="primary" class="btn-apply" @click="applyDateFilter()" :disabled="checkSelectedDates">Apply</b-link >
    </div>
  </div>
</template>
<script>
import VueSlider from "vue-slider-component";
import Datepicker from "vuejs-datepicker";
import moment from "moment";
import _ from "lodash";

export default {
  components: {
    VueSlider,
    datepicker: Datepicker
  },

  props: {
    title: { type: String, default: "Month Slider" },
    dataPicker: { type: Array, default: () => [] },
    calendarShow: {},
    studyStartDate: {}
  },

  data() {
    return {
      monthRange: [],
      sliderValues: [],
      selectedDates: {},
      datePickerFormat: "dd MMM yyyy",
      dataPickerFromValue: new Date(),
      dataPickerToValue: new Date(),
      disableDates: {},
      disableDatesStart: {},
      disableDatesEnd: {},
      dateSelectedFromPicker: false,
      showRangeSlider: false,
      defaultDates: {}
    };
  },

  watch: {
    dataPicker: function(value) {
      if(value && value.length > 0){
        this.sliderValues = this.lastMonthCheck(value);
        this.renderPicker(this.sliderValues);
      }
    },
    calendarShow: function() {
      this.refreshSlide();
    }
  },

  methods: {
    dragEnd() {
      this.dateSelectedFromPicker = false;
      let monthSelection = this.monthRange;
      let lastDate = new Date(this.getFormattedDate(monthSelection[1]).setMonth(this.getFormattedDate(monthSelection[1]).getMonth() + 1));
      if (this.getFormattedDate(monthSelection[1]).getMonth() === new Date().getMonth() && this.getFormattedDate(monthSelection[1]).getFullYear() === new Date().getFullYear()) {
        lastDate = new Date();
      } else {
        lastDate = new Date(lastDate.setDate(lastDate.getDate() - 1));
      }
      const firstDate = new Date(this.getFormattedDate(monthSelection[0]));
      const studyStart = new Date(this.studyStartDate)
      const isStartMonthOfStudy = studyStart.getMonth() === firstDate.getMonth() && studyStart.getFullYear() === firstDate.getFullYear();
      if(isStartMonthOfStudy) {
        firstDate.setDate(studyStart.getDate())
      }
      monthSelection = [
        {
          display: moment(isStartMonthOfStudy ? firstDate : this.getFormattedDate(monthSelection[0]))
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(isStartMonthOfStudy ? firstDate : this.getFormattedDate(monthSelection[0])).format("YYYY-MM-DD")
        },
        {
          display: moment(lastDate)
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(lastDate).format("YYYY-MM-DD")
        }
      ];
      this.selectedDates = monthSelection;
      this.dataPickerFromValue = firstDate;
      this.dataPickerToValue = lastDate;
      this.disableDatesStart = {
        ranges: [{ from: new Date(1970, 1, 1), to: firstDate }]
      };
      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 0, 1), to: firstDate },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
    },
    changeFromPicker() {
      this.dateSelectedFromPicker = true;
      const startDate = this.dataPickerFromValue;
      const endDate = this.dataPickerToValue;

      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 1, 1), to: startDate },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
    },
    emitPicker(monthSelection) {
      this.$emit("onDragEnd", monthSelection);
    },
    dateChanged() {
      const monthSelection = [this.dataPickerFromValue, this.dataPickerToValue];
      const monthRange = [moment(monthSelection[0]).format("MMM YYYY"), moment(monthSelection[1]).format("MMM YYYY")];
      const datePicker = [];
      const lesserValue = this.dataPickerFromValue.getTime() < this.studyStartDate ? this.dataPickerFromValue : this.studyStartDate;
      for (let m = moment(lesserValue); m.diff(moment(), "months") <= 0; m.add(1, "months")) {
        datePicker.push(m.format("MMM YYYY"));
        if (m.format("MMM YYYY") === moment().format("MMM YYYY")) {
          break;
        }
      }
      this.sliderValues = datePicker;
      this.monthRange = monthRange;
      this.selectedDates = [
        {
          display: moment(monthSelection[0])
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(monthSelection[0]).format("YYYY-MM-DD")
        },
        {
          display: moment(monthSelection[1])
            .format("DD MMM YYYY")
            .toUpperCase(),
          value: moment(monthSelection[1]).format("YYYY-MM-DD")
        }
      ];
      return this.selectedDates;
    },
    renderPicker(dataPicker) {
      const minPicker = dataPicker.length > 0 ? 0 : 0;
      const maxPicker = dataPicker.length > 1 ? dataPicker.length - 1 : 0;

      const firstMonth = dataPicker[minPicker] ? dataPicker[minPicker] : new Date();
      const lastMonth = dataPicker[maxPicker] ? dataPicker[maxPicker] : new Date();

      this.monthRange = [firstMonth, lastMonth];
      const ranges = {
        ranges: [{ from: new Date(), to: new Date(2050, 12, 31) }]
      };
      this.dataPickerFromValue = new Date(this.studyStartDate);
      this.dataPickerToValue = new Date();
      this.disableDates = ranges;
      this.disableDatesStart = {
        ranges: [
          { from: new Date(1970, 0, 1), to: this.dataPickerFromValue },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
      this.disableDatesEnd = {
        ranges: [
          { from: new Date(1970, 0, 1), to: this.dataPickerFromValue },
          { from: new Date(), to: new Date(2050, 12, 31) }
        ]
      };
    },
    refreshSlide() {
      if (this.$refs.slider) {
        this.$refs.slider.refresh();
      }
    },
    lastMonthCheck(months) {
      let data = _.filter(months, month => {
        return new Date().getTime() > this.getFormattedDate(month).getTime();
      });
      return data;
    },
    openStartDatePicker() {
      this.$refs.endDatePicker.close();
      this.$refs.startDatePicker.showCalendar();
    },
    openEndDatePicker() {
      this.$refs.startDatePicker.close();
      this.$refs.endDatePicker.showCalendar();
    },
    applyDateFilter(){
      if(this.dateSelectedFromPicker){
        this.emitPicker(this.dateChanged());
      }
      else{
        this.emitPicker(this.selectedDates);
      }
      this.setDefaultDates();
    },
    clearDateFilter(){
      this.renderPicker(this.sliderValues);
    },
    //Returns Date in Format which is supported by all the broswers
    getFormattedDate(date){
      let parts = date.split(" ");
      let month = parts[0];
      let year = parts[1];
      return new Date(month + " 1, " + year);
    },
    setDefaultDates() {
      const dates = {
        fromDate: this.dataPickerFromValue,
        toDate: this.dataPickerToValue
      }
      this.defaultDates = _.cloneDeep(dates);
    }
  },
  computed: {
    checkSelectedDates(){
      return moment(this.defaultDates.fromDate).format("YYYY-MM-DD") === moment(this.dataPickerFromValue).format("YYYY-MM-DD")
      && moment(this.defaultDates.toDate).format("YYYY-MM-DD") === moment(this.dataPickerToValue).format("YYYY-MM-DD");
    }
  },

  mounted() {
    if(this.dataPicker && this.dataPicker.length > 0){
      this.sliderValues = this.lastMonthCheck(this.dataPicker);
      this.renderPicker(this.sliderValues);
    }
    this.dataPickerFromValue = new Date(this.studyStartDate);
    this.$emit("init", this.dateChanged());
    this.setDefaultDates();
    this.disableDatesStart = {
      ranges: [{ from: new Date(1970, 1, 1), to: new Date(this.studyStartDate) }]
    };
  }
};
</script>
<style lang="scss" scoped>
.space-element {
  margin-top: 40px;
}

.date-cal-icon {
  cursor: pointer;
}

.btn-clear {
  color: #666669;
  height: auto;
  font-size: 14px;
  padding: 4px 24px;
  border: none;
  &:hover{
    border: none;
  }
}
.btn-apply {
  color: #fff !important;
  background-color: #4c8ce4 !important;
  border-color: #4c8ce4 !important;
  margin: 0 10px;
  padding: 4px 24px;
  border-radius: 4px;
  font-size: 14px;
  text-decoration: none;
  &.disabled {
    opacity: 0.4;
  }
}
@-moz-document url-prefix() {
  .date-cal-icon{
    padding-top: 6px;
    padding-bottom: 8px;
  }
}
</style>
